import { c as _c } from "react/compiler-runtime";
import { faArrowRight, faCalendar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col, Container, Row } from "react-bootstrap";
export default function AboutApply() {
  const $ = _c(49);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Row><Col><h1>Apply</h1></Col></Row>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <h4 className="pb-2 mb-4" style={{
      color: "rgb(215, 215, 215)",
      borderBottom: "1px solid rgb(68, 68, 68)"
    }}>How Does Submission Work?</h4>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      backgroundColor: "rgb(26, 26, 26)",
      border: "1px solid rgb(44, 44, 44)"
    };
    t3 = <p className="fw-bold mb-3">There are two ways you can be eligible to submit:</p>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <li className="d-flex mb-3"><span className="text-success me-2">✓</span><span><strong>Previous Meme Artist:</strong> You've previously dropped a Meme Card.</span></li>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <section className="mb-5">{t1}<div className="p-4 rounded mb-4" style={t2}>{t3}<ul className="list-unstyled mb-0">{t4}<li className="d-flex"><span className="text-success me-2">✓</span><span><strong>Community Nomination:</strong> You've been nominated by one or more people giving you at least 50,000 "MemesNominee" rep.</span></li></ul></div></section>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h4 className="pb-2 mb-4" style={{
      color: "rgb(215, 215, 215)",
      borderBottom: "1px solid rgb(68, 68, 68)"
    }}>Seeking a Nomination (New Artists)</h4>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      backgroundColor: "rgb(26, 26, 26)",
      border: "1px solid rgb(44, 44, 44)"
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="mb-4">Visit the{" "}<a href="https://6529.io/waves/0ecb95d0-d8f2-48e8-8137-bfa71ee8593c" target="_blank" rel="noopener noreferrer" className="link-info">The Memes - Seeking Nomination</a>{" "}wave and share your existing work and story. Community members may then nominate you.</p>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <section className="mb-5">{t6}<div className="p-4 rounded mb-4" style={t7}>{t8}<div className="mb-4 pb-3" style={{
          borderBottom: "1px solid rgb(40, 40, 40)"
        }}><div className="mb-1 fw-bold">Gather Support</div><div style={{
            color: "rgb(154, 154, 154)"
          }}>Community members nominate you by allocating their MemesNominee rep. You'll need 50,000 rep total to qualify.</div></div><div><div className="mb-1 fw-bold">Qualify</div><div style={{
            color: "rgb(154, 154, 154)"
          }}>Once you reach 50,000 rep, you become eligible to submit Meme Cards.</div></div></div></section>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <h4 className="pb-2 mb-4" style={{
      color: "rgb(215, 215, 215)",
      borderBottom: "1px solid rgb(68, 68, 68)"
    }}>Submitting Your Meme Cards (Eligible Artists)</h4>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      backgroundColor: "rgb(26, 26, 26)",
      border: "1px solid rgb(44, 44, 44)"
    };
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="mb-4 pb-3" style={{
      borderBottom: "1px solid rgb(40, 40, 40)"
    }}><div className="mb-1 fw-bold">Three Active Submissions</div><div style={{
        color: "rgb(154, 154, 154)"
      }}>You can have up to 3 Meme Card designs submitted simultaneously.</div></div>;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  let t14;
  let t15;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="mb-4 pb-3" style={{
      borderBottom: "1px solid rgb(40, 40, 40)"
    }}><div className="mb-1 fw-bold">Replace Submissions</div><div style={{
        color: "rgb(154, 154, 154)"
      }}>If you remove a submission or one of your submissions is selected to be minted, you can submit another card to fill that spot.</div></div>;
    t14 = <div className="mb-1 fw-bold">{"Selection & Scheduling"}</div>;
    t15 = <div style={{
      color: "rgb(154, 154, 154)"
    }}>Submitted cards appear on a public leaderboard. Cards are ranked based on community support over the past 24 hours (24HV), encouraging sustained engagement over last-minute spikes.</div>;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
  } else {
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      backgroundColor: "rgb(20, 20, 20)",
      border: "1px solid rgb(40, 40, 40)"
    };
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  let t18;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <div className="mb-2 fw-bold" style={{
      color: "rgb(215, 215, 215)"
    }}><FontAwesomeIcon icon={faCalendar} width={16} className="me-2" />{" "}Checkpoint Schedule</div>;
    t18 = {
      color: "rgb(154, 154, 154)"
    };
    $[17] = t17;
    $[18] = t18;
  } else {
    t17 = $[17];
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <span style={{
      color: "#0dcaf0",
      fontWeight: "bold",
      width: "100px"
    }}>Monday</span>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <div className="d-flex align-items-center mb-1">{t19}<span className="ms-2">17:00 GMT{" "}<FontAwesomeIcon icon={faArrowRight} width={12} className="mx-1" />{" "}minted Wednesday</span></div>;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span style={{
      color: "#0dcaf0",
      fontWeight: "bold",
      width: "100px"
    }}>Wednesday</span>;
    $[21] = t21;
  } else {
    t21 = $[21];
  }
  let t22;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="d-flex align-items-center mb-1">{t21}<span className="ms-2">17:00 GMT{" "}<FontAwesomeIcon icon={faArrowRight} width={12} className="mx-1" />{" "}minted Friday</span></div>;
    $[22] = t22;
  } else {
    t22 = $[22];
  }
  let t23;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <span style={{
      color: "#0dcaf0",
      fontWeight: "bold",
      width: "100px"
    }}>Friday</span>;
    $[23] = t23;
  } else {
    t23 = $[23];
  }
  let t24;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <section className="mb-5">{t10}<div className="p-4 rounded mb-4" style={t11}>{t12}{t13}<div>{t14}{t15}<div className="mt-3 p-3 rounded" style={t16}>{t17}<div style={t18}>{t20}{t22}<div className="d-flex align-items-center">{t23}<span className="ms-2">17:00 GMT{" "}<FontAwesomeIcon icon={faArrowRight} width={12} className="mx-1" />{" "}minted Monday</span></div></div></div></div></div></section>;
    $[24] = t24;
  } else {
    t24 = $[24];
  }
  let t25;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <h4 className="pb-2 mb-4" style={{
      color: "rgb(215, 215, 215)",
      borderBottom: "1px solid rgb(68, 68, 68)"
    }}>Creative Guidelines (Important!)</h4>;
    $[25] = t25;
  } else {
    t25 = $[25];
  }
  let t26;
  let t27;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      backgroundColor: "rgb(26, 26, 26)",
      border: "1px solid rgb(44, 44, 44)"
    };
    t27 = {
      color: "rgb(154, 154, 154)"
    };
    $[26] = t26;
    $[27] = t27;
  } else {
    t26 = $[26];
    t27 = $[27];
  }
  let t28;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <a href="https://docs.google.com/presentation/d/1Aejko31qFkAIyu-Qc3Ao9tHQGbbaFCIcqrBj_kZzo_M/edit#slide=id.p1" target="_blank" rel="noopener noreferrer" className="link-info">Artist Brief</a>;
    $[28] = t28;
  } else {
    t28 = $[28];
  }
  let t29;
  let t30;
  let t31;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <p style={t27} className="mb-3">Carefully read the{" "}{t28}{" "}before submitting. It outlines the collection's mission, vision, themes, and guidelines. <br /> High-quality, mission-aligned submissions perform best. Low-effort or off-theme submissions are unlikely to be chosen.</p>;
    t30 = <p style={{
      color: "rgb(154, 154, 154)"
    }} className="mb-3">Your Meme Card can be made in any medium — art, photo, video, interactive code, or something more experimental.</p>;
    t31 = <p style={{
      color: "rgb(154, 154, 154)"
    }} className="mb-4">You're the expert on your art — we're here to help with The Memes style and mission. Sharing drafts or brainstorming early often leads to better outcomes for everyone.</p>;
    $[29] = t29;
    $[30] = t30;
    $[31] = t31;
  } else {
    t29 = $[29];
    t30 = $[30];
    t31 = $[31];
  }
  let t32;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      borderTop: "1px solid rgb(40, 40, 40)"
    };
    $[32] = t32;
  } else {
    t32 = $[32];
  }
  let t33;
  let t34;
  let t35;
  let t36;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      borderBottom: "1px solid rgb(40, 40, 40)"
    };
    t34 = <div className="mb-1 fw-bold">Need Artistic Feedback?</div>;
    t35 = {
      color: "rgb(154, 154, 154)"
    };
    t36 = <span className="text-success me-2">✓</span>;
    $[33] = t33;
    $[34] = t34;
    $[35] = t35;
    $[36] = t36;
  } else {
    t33 = $[33];
    t34 = $[34];
    t35 = $[35];
    t36 = $[36];
  }
  let t37;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <span className="text-light">@6529er</span>;
    $[37] = t37;
  } else {
    t37 = $[37];
  }
  let t38;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <span className="text-light">@teexels</span>;
    $[38] = t38;
  } else {
    t38 = $[38];
  }
  let t39;
  let t40;
  let t41;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t39 = <div className="mb-4 pb-3" style={t33}>{t34}<div style={t35}>{t36} DM{" "}{t37}{", "}{t38}{", and "}<span className="text-light">@darrensrs</span> into a group chat for feedback and creative guidance.</div></div>;
    t40 = <div className="mb-1 fw-bold">General Questions?</div>;
    t41 = {
      color: "rgb(154, 154, 154)"
    };
    $[39] = t39;
    $[40] = t40;
    $[41] = t41;
  } else {
    t39 = $[39];
    t40 = $[40];
    t41 = $[41];
  }
  let t42;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t42 = <a href="https://6529.io/waves/e2dae377-d27d-4a69-8b77-38d88fad4d01" target="_blank" rel="noopener noreferrer" className="link-info">The Memes - FAQ wave</a>;
    $[42] = t42;
  } else {
    t42 = $[42];
  }
  let t43;
  let t44;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t43 = <div style={t41}>Visit{" "}{t42}{" "}after reading the{" "}<a href="https://docs.google.com/presentation/d/1Aejko31qFkAIyu-Qc3Ao9tHQGbbaFCIcqrBj_kZzo_M/edit#slide=id.p1" target="_blank" rel="noopener noreferrer" className="link-info">Artist Brief</a>{"."}</div>;
    t44 = {
      color: "rgb(154, 154, 154)"
    };
    $[43] = t43;
    $[44] = t44;
  } else {
    t43 = $[43];
    t44 = $[44];
  }
  let t45;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <span className="text-success me-2">✓</span>;
    $[45] = t45;
  } else {
    t45 = $[45];
  }
  let t46;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <div className="mt-4 pt-4" style={t32}>{t39}<div>{t40}{t43}<div style={t44} className="mt-2">{t45}For other inquiries, email us at{" "}<a href="mailto:collections@6529.io" target="_blank" rel="noopener noreferrer" className="link-info">collections@6529.io</a>{"."}</div></div></div>;
    $[46] = t46;
  } else {
    t46 = $[46];
  }
  let t47;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t47 = {
      backgroundColor: "rgb(20, 20, 20)",
      border: "1px solid rgb(40, 40, 40)"
    };
    $[47] = t47;
  } else {
    t47 = $[47];
  }
  let t48;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <Container>{t0}<Row className="pt-3 pb-3"><Col>{t5}{t9}{t24}<section className="mb-5">{t25}<div className="p-4 rounded mb-4" style={t26}>{t29}{t30}{t31}{t46}<div className="p-3 rounded text-center mt-4" style={t47}><p className="mb-0 fst-italic small" style={{
                  color: "rgb(154, 154, 154)"
                }}>We receive many messages; thank you for your patience if responses are delayed.</p></div></div></section></Col></Row></Container>;
    $[48] = t48;
  } else {
    t48 = $[48];
  }
  return t48;
}